import { useMemo } from 'react';
import type { CustomField, Project, SavedFilter } from '@missions/types';
import { useApi } from '../../lib/hooks';

export type GroupBy = 'status' | 'assignee' | 'priority' | 'dueAt' | 'none';
export type Sort = 'manual' | 'dueAt' | '-dueAt' | 'priority' | 'createdAt' | '-createdAt' | 'title' | 'updatedAt';
export type ViewKey = 'overview' | 'list' | 'board' | 'calendar' | 'table' | 'stickies';

export interface ListState {
  q: string;
  assignee: string | null;
  due: 'any' | 'overdue' | 'today' | 'this_week' | 'no_date';
  me: boolean;
  showClosed: boolean;
  groupBy: GroupBy;
  sort: Sort;
  rules: SavedFilter['rules'];
}

export const DEFAULT_LIST: ListState = { q: '', assignee: null, due: 'any', me: false, showClosed: true, groupBy: 'status', sort: 'manual', rules: [] };

/** Serialises the toolbar state into the API's SavedFilter JSON. */
export function filterJson(s: ListState): string {
  const rules = [...s.rules];
  if (s.assignee) rules.push({ field: 'assignee', op: 'in', value: [s.assignee] });
  const f: SavedFilter = { match: 'all', rules, quick: { me: s.me || undefined, showClosed: s.showClosed, due: s.due === 'any' ? undefined : s.due } };
  return JSON.stringify(f);
}

export function useProjectData(projectId: string) {
  const project = useApi('projects.get', { params: { id: projectId } });
  const fields = useApi('customFields.list', { query: { workspaceId: project.data?.workspaceId ?? '', projectId } }, { enabled: !!project.data });
  return useMemo(
    () => ({ project: project.data as Project | undefined, fields: (fields.data?.data ?? []) as CustomField[], isPending: project.isPending, isError: project.isError, refetch: project.refetch }),
    [project.data, project.isPending, project.isError, project.refetch, fields.data],
  );
}
